// extracted by mini-css-extract-plugin
export default {"admonition":"admonition_Gfwi","admonitionHeading":"admonitionHeading_f1Ed","admonitionIcon":"admonitionIcon_kpSf","admonitionContent":"admonitionContent_UjKb"};